module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Admin */

(function(fox) {
	"use strict";

	fox.registerWidget('Layout_Admin_Simple', {

		configure: function () {

			this.registerOptions('', {
				template: 'layout_admin_simple'
			});

			this.callParent('configure', arguments);
		}

	}, 'Layout_Admin');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/admin/simple.js
// module id = 324
// module chunks = 2